import { PatientInfoType, PatientType } from '@/shared/types'
import { getDateFormat } from '@/shared/utils'
import { DATE_FORMAT } from '@/shared/constants'

interface IPatientData {
  patient_id?: number
  surname: string
  name: string
  patronymic?: string
  date: string
  email?: string
  cart_number?: string
  phone?: string
}

export class PatientDataMapper {
  static mapPatientCreationData = (
    patientInfo: PatientInfoType
  ): IPatientData => {
    const { cartNumber, date, phone, email, patronymic, name, surname } =
      patientInfo

    const patientCreationData: IPatientData = {
      date: getDateFormat(new Date(date), DATE_FORMAT.dmyDot),
      name,
      surname,
    }

    if (phone) {
      patientCreationData.phone = phone
    }
    if (email) {
      patientCreationData.email = email
    }
    if (patronymic) {
      patientCreationData.patronymic = patronymic
    }
    if (cartNumber) {
      patientCreationData.cart_number = cartNumber
    }

    return patientCreationData
  }

  static mapPatientEditionData = (patientInfo: PatientType): IPatientData => {
    const { id, date } = patientInfo

    const patientEditionData: IPatientData = {
      ...patientInfo,
      patient_id: id,
      date: getDateFormat(new Date(date), DATE_FORMAT.dmyDot),
    }

    return patientEditionData
  }
}
